<div class="card">
    <div class="card-row">
        <span class="card-label"> {{ label | localize }} </span>
        <div>
            <span> {{ value }} </span> / <span> {{ maxValue }} </span> <span *ngIf="estimate"> * </span>
        </div>
    </div>
    <p-progressBar
        class="progressBar"
        [ngClass]="{
            'progressBar-colour1': ((value / maxValue) * 100) <= 20,
            'progressBar-colour2': ((value / maxValue) * 100) > 20 && ((value / maxValue) * 100) <= 40,
            'progressBar-colour3': ((value / maxValue) * 100) > 40 && ((value / maxValue) * 100) <= 60,
            'progressBar-colour4': ((value / maxValue) * 100) > 60 && ((value / maxValue) * 100) <= 80,
            'progressBar-colour5': ((value / maxValue) * 100) > 80
        }"
        [value]="((value / maxValue) * 100)"
        [showValue]="false"
    ></p-progressBar>
</div>